import CredentialForm from './CredentialForm';

export default CredentialForm;
